export default "__VITE_ASSET__BbColMDu__"